import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export default function Faq({ faqs }) {
  return (
    <section id="faq" data-testid="faq-section" className="bg-background">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <SectionHeading
          align="center"
          index="06"
          overline="Help"
          title="Frequently Asked Questions"
          sub="Everything you need to know about ordering, shipping, and returns."
        />
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-neutral-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-heading text-[15px] font-semibold text-neutral-900 hover:no-underline sm:text-base">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-neutral-500">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
